export default "__VITE_ASSET__68wS8cKd__"